import {
  EngineExecutionLimitsPolicy,
  ENGINE_EXECUTION_LIMITS_DEFAULTS,
  type EngineExecutionLimitsPolicyConfig,
} from "./EngineExecutionLimitsPolicy";

export class EngineExecutionLimitsPolicyFactory {
  create(overrides?: Partial<EngineExecutionLimitsPolicyConfig>): EngineExecutionLimitsPolicy {
    return new EngineExecutionLimitsPolicy({ ...ENGINE_EXECUTION_LIMITS_DEFAULTS, ...overrides });
  }
}
